export const BANNER_STRIP_DEFAULT_ICONS = {
  membership: 'marketplaceMec',
  light: 'SparkleIcon-fill',
} as const;
